import type { ReactNode } from 'react';

/**
 * VisuallyHidden — text that only assistive technology receives.
 *
 * No direct corpus source. The design files name their controls with
 * `aria-label` (`SI:96-98`, `JC:32-34`)
 * and drop decoration out of the accessibility tree with `aria-hidden`
 * (`JC:42-45`), so there is no screen-reader-only
 * utility in them to lift. Saying that is worth more than a citation that would
 * not survive being checked.
 *
 * The hidden sentence is a child, never a literal inside this file: it is read
 * aloud, so it is copy, and copy comes from the caller's catalogue.
 */
export function VisuallyHidden({ children }: { readonly children: ReactNode }) {
  return <span className="rp-visually-hidden">{children}</span>;
}
